import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {InterestService} from '../../../shared/services/interest.service';
import {empty, in_array} from '../../../functions';
import {alertMessages, AlertService} from '../../../shared/services/alert.service';
import {ValidationService} from '../../../shared/services/validation.service';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import { StudentProfileService } from '../../../api/services/student-profile.service';
import { MAX_AREA_OF_INTERESTS } from '../../../shared/utils/student-profile.utils';

@Component({
    selector: 'app-modal-student-profile-interests',
    templateUrl: './modal-student-profile-interests.component.html',
    styleUrls: ['./modal-student-profile-interests.component.scss'],
    standalone: false
})
export class ModalStudentProfileInterestsComponent implements OnInit {

  public data:any;

  in_array = in_array;

  maxAmount = MAX_AREA_OF_INTERESTS;

  public profile:any = {
    id: '',
    areaOfInterests: <any> []
  };

  validation:any = {
    validated: false,
    valid: false,
    fields: {
      selectedAreaOfInterests: {
          regex: 'required',
          error: false
        }

    }

  }

  public selectedAreaOfInterests:any = [];

  public areaOfInterests:any = [];

  constructor(public activeModal: NgbActiveModal,
              public interestsService: InterestService,
              private studentProfileService: StudentProfileService,
              private alertService: AlertService,
              private validationService: ValidationService) { }

  /**
   * On ng init
   */
  ngOnInit(): void {

    this.profile = Object.assign({}, this.data);
    this.selectedAreaOfInterests = Object.assign([], this.profile.areaOfInterests);

  }

  /**
   * Validate the registration form
   */
  validateForm() {
    let valid = true;
    const self:any = this;

    // Set entity data selectors
    const $entitySelectors = ['selectedAreaOfInterests'];

    // Check entity columns
    for (const $entitySelector of $entitySelectors) {

      if ( this.validation['fields'].hasOwnProperty($entitySelector) ) {

        if (this.validation['fields'][$entitySelector].hasOwnProperty('error')) {

          const entity = this.validation['fields'][$entitySelector];

          if (entity.hasOwnProperty('regex') ) {
            const value = self[$entitySelector];
            const regPattern = entity['regex'];

            // Set validation flags
            if (!this.validationService.regexValidation(regPattern, value)) {
              this.validation['fields'][$entitySelector]['error'] = true;
              valid = false;

            } else {
              this.validation['fields'][$entitySelector]['error'] = false;
            }

          }

        } else {
          for (const key in this.validation['fields'][$entitySelector]) {

            if (!empty(this.validation['fields'][$entitySelector][key])) {

              const entity = this.validation['fields'][$entitySelector][key];

              if (entity.hasOwnProperty('regex') ) {
                const value = self[$entitySelector][key];
                const regPattern = entity['regex'];

                // Set validation flags
                if (!this.validationService.regexValidation(regPattern, value)) {
                  this.validation['fields'][$entitySelector][key]['error'] = true;
                  valid = false;

                } else {
                  this.validation['fields'][$entitySelector][key]['error'] = false;
                }

              }
            }
          }
        }
      }
    }

    // Set validation flags for step
    this.validation['valid'] = valid;
    this.validation['validated'] = true;

    return valid;
  }

  /**
   * Show validation error
   *
   * Determine if a validation error needs to be visible to client
   *
   * @param stepNumber
   * @param $entity
   * @param $entityProperty
   */
  showValidationError($entity: string, $entityProperty: string = '', $property:string = '') {

    if (!empty($entityProperty)) {

      if (!empty($property)) {
        if (this.validation['validated'] && this.validation['validated']['fields'][$entity][$entityProperty][$property]['error'] === true) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.validation['validated'] && this.validation['fields'][$entity][$entityProperty]['error'] === true) {
          return true;
        } else {
          return false;
        }
      }
    }
    else {
      if (this.validation['validated'] && this.validation['fields'][$entity]['error'] === true) {
        return true;
      } else {
        return false;
      }
    }

  }

  /**
   * Save
   *
   * @constructor
   */
  Save() {

    const valid = this.validateForm();

    if (valid) {

      this.studentProfileService.setStudentProfileAreaOfInterest({ profileId: this.profile.id, body: this.selectedAreaOfInterests }).pipe(catchError((err) => { this.alertService.errorWithReport(err, 'studentProfile:saveInterests'); return of(false as const); })).subscribe( (result) => {

        if (result !== false) {
          this.alertService.success(alertMessages.successDataSaved);
          this.activeModal.close(true);
        }

      });

    }

  }

}
